/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import { fidoV2 as fido } from '@bsd/ui-utils';
export class FetchResult {
    constructor(data, httpStatus, headers, messages) {
        this.data = data;
        this.httpStatus = httpStatus;
        this.headers = headers;
        this.messages = messages;
    }
}
export class ApiSA {
    constructor(baseUrl) {
        this.jsonParseReviver = undefined;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Dismiss the Ftue to not see it again
     * @param type (optional)
     * @param tracking_id (optional) The tracking id or visitor session id.
     * @return Success
     */
    disable(type, tracking_id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url_ = "/Ftue/disable?";
            if (type === null)
                throw new Error("The parameter 'type' cannot be null.");
            else if (type !== undefined)
                url_ += "type=" + encodeURIComponent("" + type) + "&";
            url_ = url_.replace(/[?&]$/, "");
            // let fullUrl_ = this.baseUrl + url_;
            if (!options) {
                options = {};
            }
            options.rawResponse = true;
            options.headers = Object.assign(Object.assign({}, options.headers), { "tracking-id": tracking_id !== undefined && tracking_id !== null ? "" + tracking_id : "" });
            let callOptions = {
                baseUrl: this.baseUrl,
                key: url_,
                url: url_,
                originalUrl: "Ftue/disable",
                method: "GET"
            };
            try {
                let result = yield fido.fetch(callOptions, options);
                const body = (result === null || result === void 0 ? void 0 : result.body) || (result === null || result === void 0 ? void 0 : result.data) || result || {};
                return new FetchResult(body, result.status, result.headers, null);
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Re-enable the Ftue to see it again
     * @param type (optional)
     * @param tracking_id (optional) The tracking id or visitor session id.
     * @return Success
     */
    enable(type, tracking_id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url_ = "/Ftue/enable?";
            if (type === null)
                throw new Error("The parameter 'type' cannot be null.");
            else if (type !== undefined)
                url_ += "type=" + encodeURIComponent("" + type) + "&";
            url_ = url_.replace(/[?&]$/, "");
            // let fullUrl_ = this.baseUrl + url_;
            if (!options) {
                options = {};
            }
            options.rawResponse = true;
            options.headers = Object.assign(Object.assign({}, options.headers), { "tracking-id": tracking_id !== undefined && tracking_id !== null ? "" + tracking_id : "" });
            let callOptions = {
                baseUrl: this.baseUrl,
                key: url_,
                url: url_,
                originalUrl: "Ftue/enable",
                method: "GET"
            };
            try {
                let result = yield fido.fetch(callOptions, options);
                const body = (result === null || result === void 0 ? void 0 : result.body) || (result === null || result === void 0 ? void 0 : result.data) || result || {};
                return new FetchResult(body, result.status, result.headers, null);
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Notify the backend that an account has been selected by the user on the front-end.
    This is important for Legacy Applications which don't use Resource based Account Selections
     * @param tracking_id (optional) The tracking id or visitor session id.
     * @param body (optional)
     * @return Success
     */
    accountSelection(tracking_id, body, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url_ = "/Legacy/accountSelection";
            url_ = url_.replace(/[?&]$/, "");
            // let fullUrl_ = this.baseUrl + url_;
            const content_ = JSON.stringify(body);
            if (!options) {
                options = {};
            }
            options.rawResponse = true;
            options.headers = Object.assign(Object.assign({}, options.headers), { "tracking-id": tracking_id !== undefined && tracking_id !== null ? "" + tracking_id : "" });
            let callOptions = {
                baseUrl: this.baseUrl,
                key: url_,
                url: url_,
                originalUrl: "Legacy/accountSelection",
                data: content_,
                method: "POST"
            };
            try {
                let result = yield fido.fetch(callOptions, options);
                const body = (result === null || result === void 0 ? void 0 : result.body) || (result === null || result === void 0 ? void 0 : result.data) || result || {};
                return new FetchResult(body, result.status, result.headers, null);
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Get Megamenu enablement decision
     * @param tracking_id (optional) The tracking id or visitor session id.
     * @return Success
     */
    megamenuEnablement(tracking_id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url_ = "/MegamenuEnablement";
            url_ = url_.replace(/[?&]$/, "");
            // let fullUrl_ = this.baseUrl + url_;
            if (!options) {
                options = {};
            }
            options.rawResponse = true;
            options.headers = Object.assign(Object.assign({}, options.headers), { "tracking-id": tracking_id !== undefined && tracking_id !== null ? "" + tracking_id : "" });
            let callOptions = {
                baseUrl: this.baseUrl,
                key: url_,
                url: url_,
                originalUrl: "MegamenuEnablement",
                method: "GET"
            };
            try {
                let result = yield fido.fetch(callOptions, options);
                const body = (result === null || result === void 0 ? void 0 : result.body) || (result === null || result === void 0 ? void 0 : result.data) || result || {};
                return new FetchResult(body, result.status, result.headers, null);
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Get a User's Navigation Data based on the custGuid present in the Authorization Header
     * @param tracking_id (optional) The tracking id or visitor session id.
     * @return Success
     */
    navigation(tracking_id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url_ = "/Navigation";
            url_ = url_.replace(/[?&]$/, "");
            // let fullUrl_ = this.baseUrl + url_;
            if (!options) {
                options = {};
            }
            options.rawResponse = true;
            options.headers = Object.assign(Object.assign({}, options.headers), { "tracking-id": tracking_id !== undefined && tracking_id !== null ? "" + tracking_id : "" });
            let callOptions = {
                baseUrl: this.baseUrl,
                key: url_,
                url: url_,
                originalUrl: "Navigation",
                method: "GET"
            };
            try {
                let result = yield fido.fetch(callOptions, options);
                const body = (result === null || result === void 0 ? void 0 : result.body) || (result === null || result === void 0 ? void 0 : result.data) || result || {};
                return new FetchResult(body, result.status, result.headers, null);
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * Get a User's Navigation Data based on the custGuid present in the Authorization Header
     * @param tracking_id (optional) The tracking id or visitor session id.
     * @return Success
     */
    getOrCreate(tracking_id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let url_ = "/Session/getOrCreate";
            url_ = url_.replace(/[?&]$/, "");
            // let fullUrl_ = this.baseUrl + url_;
            if (!options) {
                options = {};
            }
            options.rawResponse = true;
            options.headers = Object.assign(Object.assign({}, options.headers), { "tracking-id": tracking_id !== undefined && tracking_id !== null ? "" + tracking_id : "" });
            let callOptions = {
                baseUrl: this.baseUrl,
                key: url_,
                url: url_,
                originalUrl: "Session/getOrCreate",
                method: "GET"
            };
            try {
                let result = yield fido.fetch(callOptions, options);
                const body = (result === null || result === void 0 ? void 0 : result.body) || (result === null || result === void 0 ? void 0 : result.data) || result || {};
                return new FetchResult(body, result.status, result.headers, null);
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
}
export class AccountSelection {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.authGuid = _data["authGuid"];
            this.orderId = _data["orderId"];
            this.orderReferenceNumber = _data["orderReferenceNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSelection();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authGuid"] = this.authGuid;
        data["orderId"] = this.orderId;
        data["orderReferenceNumber"] = this.orderReferenceNumber;
        return data;
    }
}
/** Ftue Dismissal Type */
export var FtueDismissalType;
(function (FtueDismissalType) {
    FtueDismissalType["Nav"] = "Nav";
    FtueDismissalType["Hub"] = "Hub";
})(FtueDismissalType || (FtueDismissalType = {}));
export var NavigationAccountBillerType;
(function (NavigationAccountBillerType) {
    NavigationAccountBillerType["Unknown"] = "Unknown";
    NavigationAccountBillerType["SingleView"] = "SingleView";
    NavigationAccountBillerType["CableServiceGroup"] = "CableServiceGroup";
    NavigationAccountBillerType["Amdocs"] = "Amdocs";
})(NavigationAccountBillerType || (NavigationAccountBillerType = {}));
export class NavigationOrder {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderReferenceNumber = _data["orderReferenceNumber"];
            this.associatedAuthGuid = _data["associatedAuthGuid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationOrder();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderReferenceNumber"] = this.orderReferenceNumber;
        data["associatedAuthGuid"] = this.associatedAuthGuid;
        return data;
    }
}
export var NavigationServiceType;
(function (NavigationServiceType) {
    NavigationServiceType["SdWan"] = "SdWan";
    NavigationServiceType["ManagedRouter"] = "ManagedRouter";
    NavigationServiceType["ComcastBusinessMobile"] = "ComcastBusinessMobile";
    NavigationServiceType["ComcastBusinessMobileActive"] = "ComcastBusinessMobileActive";
    NavigationServiceType["ConnectionPro"] = "ConnectionPro";
    NavigationServiceType["Odia"] = "Odia";
    NavigationServiceType["BusinessInternet"] = "BusinessInternet";
    NavigationServiceType["BusinessInternetOffNet"] = "BusinessInternetOffNet";
    NavigationServiceType["Pri"] = "Pri";
    NavigationServiceType["SecurityEdge"] = "SecurityEdge";
    NavigationServiceType["SecurityEdgeExtendedCoverage"] = "SecurityEdgeExtendedCoverage";
    NavigationServiceType["Sip"] = "Sip";
    NavigationServiceType["BusinessTv"] = "BusinessTv";
    NavigationServiceType["BusinessVoice"] = "BusinessVoice";
    NavigationServiceType["Edi"] = "Edi";
    NavigationServiceType["Ens"] = "Ens";
    NavigationServiceType["Epl"] = "Epl";
    NavigationServiceType["Evpl"] = "Evpl";
    NavigationServiceType["Ddos"] = "Ddos";
    NavigationServiceType["BusinessVoiceEdge"] = "BusinessVoiceEdge";
    NavigationServiceType["VoiceEdgeSelect"] = "VoiceEdgeSelect";
    NavigationServiceType["VoiceMobility"] = "VoiceMobility";
    NavigationServiceType["WiFiPro"] = "WiFiPro";
    NavigationServiceType["WirelessBackup"] = "WirelessBackup";
})(NavigationServiceType || (NavigationServiceType = {}));
export class NavigationUiAccountModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.version = _data["version"];
            this.accountNumber = _data["accountNumber"];
            this.hasValidAccountIdentifier = _data["hasValidAccountIdentifier"];
            this.isPreAccount = _data["isPreAccount"];
            this.isPreInstall = _data["isPreInstall"];
            this.isPostInstall = _data["isPostInstall"];
            this.isActive = _data["isActive"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.isOrion = _data["isOrion"];
            this.isSingleView = _data["isSingleView"];
            this.isClosed = _data["isClosed"];
            this.isSuspended = _data["isSuspended"];
            this.isDisconnected = _data["isDisconnected"];
            this.isBvMigrationEligible = _data["isBvMigrationEligible"];
            if (Array.isArray(_data["services"])) {
                this.services = [];
                for (let item of _data["services"])
                    this.services.push(item);
            }
            this.address = _data["address"] ? NavigationUserAccountAddress.fromJS(_data["address"]) : undefined;
            this.accountBillerType = _data["accountBillerType"];
            if (_data["dataSourceVersions"]) {
                this.dataSourceVersions = {};
                for (let key in _data["dataSourceVersions"]) {
                    if (_data["dataSourceVersions"].hasOwnProperty(key))
                        this.dataSourceVersions[key] = _data["dataSourceVersions"][key];
                }
            }
            this.authGuid = _data["authGuid"];
            this.orderId = _data["orderId"];
            this.orderReferenceNumber = _data["orderReferenceNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationUiAccountModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["version"] = this.version;
        data["accountNumber"] = this.accountNumber;
        data["hasValidAccountIdentifier"] = this.hasValidAccountIdentifier;
        data["isPreAccount"] = this.isPreAccount;
        data["isPreInstall"] = this.isPreInstall;
        data["isPostInstall"] = this.isPostInstall;
        data["isActive"] = this.isActive;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["isOrion"] = this.isOrion;
        data["isSingleView"] = this.isSingleView;
        data["isClosed"] = this.isClosed;
        data["isSuspended"] = this.isSuspended;
        data["isDisconnected"] = this.isDisconnected;
        data["isBvMigrationEligible"] = this.isBvMigrationEligible;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["accountBillerType"] = this.accountBillerType;
        if (this.dataSourceVersions) {
            data["dataSourceVersions"] = {};
            for (let key in this.dataSourceVersions) {
                if (this.dataSourceVersions.hasOwnProperty(key))
                    data["dataSourceVersions"][key] = this.dataSourceVersions[key];
            }
        }
        data["authGuid"] = this.authGuid;
        data["orderId"] = this.orderId;
        data["orderReferenceNumber"] = this.orderReferenceNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}
export class NavigationUiModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.version = _data["version"];
            if (Array.isArray(_data["userNavigationSession"])) {
                this.userNavigationSession = [];
                for (let item of _data["userNavigationSession"])
                    this.userNavigationSession.push(NavigationUserSession.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [];
                for (let item of _data["orders"])
                    this.orders.push(NavigationOrder.fromJS(item));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.defaultAccountAuthGuid = _data["defaultAccountAuthGuid"];
            this.custGuid = _data["custGuid"];
            this.firstTimeUserExperienceEnabled = _data["firstTimeUserExperienceEnabled"];
            this.hubFirstTimeUserExperienceEnabled = _data["hubFirstTimeUserExperienceEnabled"];
            if (Array.isArray(_data["services"])) {
                this.services = [];
                for (let item of _data["services"])
                    this.services.push(item);
            }
            this.hasBusinessVoiceTelephoneNumber = _data["hasBusinessVoiceTelephoneNumber"];
            this.hasBveManageRole = _data["hasBveManageRole"];
            if (_data["dataSourceVersions"]) {
                this.dataSourceVersions = {};
                for (let key in _data["dataSourceVersions"]) {
                    if (_data["dataSourceVersions"].hasOwnProperty(key))
                        this.dataSourceVersions[key] = _data["dataSourceVersions"][key];
                }
            }
            if (_data["accountRoles"]) {
                this.accountRoles = {};
                for (let key in _data["accountRoles"]) {
                    if (_data["accountRoles"].hasOwnProperty(key))
                        this.accountRoles[key] = _data["accountRoles"][key] !== undefined ? _data["accountRoles"][key] : [];
                }
            }
            this.refreshAfterMillis = _data["refreshAfterMillis"];
            this.sessionFound = _data["sessionFound"];
            this.selectedAccount = _data["selectedAccount"] ? AccountSelection.fromJS(_data["selectedAccount"]) : undefined;
            this.hasOrionAndNonOrionAccounts = _data["hasOrionAndNonOrionAccounts"];
            if (Array.isArray(_data["billingAccounts"])) {
                this.billingAccounts = [];
                for (let item of _data["billingAccounts"])
                    this.billingAccounts.push(NavigationUiAccountModel.fromJS(item));
            }
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [];
                for (let item of _data["accounts"])
                    this.accounts.push(NavigationUiAccountModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationUiModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["version"] = this.version;
        if (Array.isArray(this.userNavigationSession)) {
            data["userNavigationSession"] = [];
            for (let item of this.userNavigationSession)
                data["userNavigationSession"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["defaultAccountAuthGuid"] = this.defaultAccountAuthGuid;
        data["custGuid"] = this.custGuid;
        data["firstTimeUserExperienceEnabled"] = this.firstTimeUserExperienceEnabled;
        data["hubFirstTimeUserExperienceEnabled"] = this.hubFirstTimeUserExperienceEnabled;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["hasBusinessVoiceTelephoneNumber"] = this.hasBusinessVoiceTelephoneNumber;
        data["hasBveManageRole"] = this.hasBveManageRole;
        if (this.dataSourceVersions) {
            data["dataSourceVersions"] = {};
            for (let key in this.dataSourceVersions) {
                if (this.dataSourceVersions.hasOwnProperty(key))
                    data["dataSourceVersions"][key] = this.dataSourceVersions[key];
            }
        }
        if (this.accountRoles) {
            data["accountRoles"] = {};
            for (let key in this.accountRoles) {
                if (this.accountRoles.hasOwnProperty(key))
                    data["accountRoles"][key] = this.accountRoles[key];
            }
        }
        data["refreshAfterMillis"] = this.refreshAfterMillis;
        data["sessionFound"] = this.sessionFound;
        data["selectedAccount"] = this.selectedAccount ? this.selectedAccount.toJSON() : undefined;
        data["hasOrionAndNonOrionAccounts"] = this.hasOrionAndNonOrionAccounts;
        if (Array.isArray(this.billingAccounts)) {
            data["billingAccounts"] = [];
            for (let item of this.billingAccounts)
                data["billingAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}
export class NavigationUserAccountAddress {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.address1 = _data["address1"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationUserAccountAddress();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        return data;
    }
}
export class NavigationUserSession {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.firstSeen = _data["firstSeen"] ? new Date(_data["firstSeen"].toString()) : undefined;
            this.selectedAccount = _data["selectedAccount"] ? AccountSelection.fromJS(_data["selectedAccount"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationUserSession();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["firstSeen"] = this.firstSeen ? this.firstSeen.toISOString() : undefined;
        data["selectedAccount"] = this.selectedAccount ? this.selectedAccount.toJSON() : undefined;
        return data;
    }
}
export var UserAccountRole;
(function (UserAccountRole) {
    UserAccountRole["BusinessOwner"] = "BusinessOwner";
    UserAccountRole["Administrator"] = "Administrator";
    UserAccountRole["ServiceUser"] = "ServiceUser";
    UserAccountRole["BillPayManager"] = "BillPayManager";
    UserAccountRole["ALL"] = "ALL";
})(UserAccountRole || (UserAccountRole = {}));
//# sourceMappingURL=index.js.map